import type Luminary from '@lumen5/luminary';
import type { TextAsset } from '@lumen5/luminary';

import { DISCLAIMER_TEXT_ASSET_NAME } from './disclaimer-text-operations';

export function getDisclaimerText(luminary: Readonly<Luminary>): string | null {
    for (const scene of luminary.scenes) {
        const asset = scene.getAssetByName(DISCLAIMER_TEXT_ASSET_NAME) as TextAsset | undefined;
        if (asset) return asset.text;
    }
    return null;
}
